module.exports = __webpack_public_path__ + "img/Zacky.4280d4bc.png";